const white = '#fff';
const catskillWhite = '#E1E5F0';
const black = '#000';
const grey = '#EBEBEB';
const grey1 = '#f5f6f7';
const grey2 = '#DCDFEB';
const periwinkleGray = '#DBDFEF';
const darkGrey = '#ededee';
const success = '#35C759';
const danger = '#EF2A5A';
const dangerSoft = '#F2DEDE';
const dangerBorder = '#BC514E';
const pink = '#c10f81';
const focus = '#0c273b';

export const colors = {
  white,
  black,
  catskillWhite,
  grey,
  grey1,
  grey2,
  periwinkleGray,
  darkGrey,
  success,
  danger,
  dangerBorder,
  dangerSoft,
  pink,
  focus,
} as const;
